import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { ErrorState } from '@/shared/ui/feedback/ErrorState';
import { useDashboard } from '@/entities/dashboard';
import { extractErrorMessage } from '@/shared/api/errors';
import {
  FeaturesDashboardMonthlyParcelsChart,
  FeaturesDashboardPartyStatusChart,
  FeaturesDashboardStatsGrid,
} from '@/features/dashboard';

export const WidgetsDashboardMain = () => {
  const { t } = useTranslation();
  const query = useDashboard();

  return (
    <>
      <PageHeader title={t('dashboard.title')} subtitle={t('dashboard.subtitle')} />
      <div className="space-y-4 px-4 py-4 lg:px-6 lg:py-6">
        {query.isLoading ? (
          <div className="flex justify-center py-12">
            <Spinner size="lg" />
          </div>
        ) : query.error ? (
          <ErrorState
            message={extractErrorMessage(query.error, t('dashboard.errorLoad'))}
            onRetry={() => void query.refetch()}
          />
        ) : query.data ? (
          <>
            <FeaturesDashboardStatsGrid data={query.data} />
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
              <FeaturesDashboardMonthlyParcelsChart data={query.data.monthly_parcels} />
              <FeaturesDashboardPartyStatusChart data={query.data.party_by_status} />
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};
